import React from 'react'
import {Link, withRouter} from 'react-router-dom';
import { connect } from 'react-redux'
import { do_action } from '../../actions'

class Footer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            social: {}
        }
    }

    // componentWillMount() {
    //     do_action('get_link_social', {})
    //         .then(data => {
    //             if (data.signal) {
    //                 this.setState({social: data.data})
    //             }
    //         })
    //         .catch(err => console.log(err));
    // }

    render() {
        let {social} = this.state
        let { pageSeo } = this.props
        pageSeo = pageSeo || {}
        return ""
        return (
            <div className="footer">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5">
                                <a href={`/${pageSeo['home'] || ''}`} className="f-logo">
                                    <img src="/images/new/ruhu-logo-14-150.png" alt="Ruhu Logo" width={150}/>
                                </a>
                                <ul className="list-inline f-social">
                                    <li><a href={social.youtube || '/'} target="_blank"><span className="fa fa-youtube" /></a></li>
                                    <li><a href={social.instagram || '/'} target="_blank"><span className="fa fa-instagram" /></a></li>
                                    <li><a href={social.facebook || '/'} target="_blank"><span className="fa fa-facebook" /></a></li>
                                </ul>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                    <div className="title">Informations</div>
                                    <ul className="list-unstyled f-list">
                                        <li><a href={`/${pageSeo['about-us'] || 'about-us'}`}>About Us</a></li>
                                        <li><a href={`/${pageSeo['privacy-policy'] || 'privacy-policy'}`}>Privacy Policy</a></li>
                                        <li><a href={`/${pageSeo['term-conditions'] || 'term-conditions'}`}>Terms &amp; conditions</a></li>
                                    </ul>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                    <div className="title">Support</div>
                                    <ul className="list-unstyled f-list">
                                        <li><a href={`/${pageSeo['contact-us'] || 'contact-us'}`}>Contact Us</a></li>
                                        <li><a href={`/${pageSeo['faq'] || 'faq'}`}>FAQs</a></li>
                                    </ul>
                                </div>
                                    {this.props.customer._id && (
                                        <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                            <div className="title">My Account</div>
                                            <ul className="list-unstyled f-list">
                                                <li><Link to="/profile">My Profile</Link></li>
                                                <li><Link to="/my-quotes">My Quotes</Link></li>
                                            </ul>
                                        </div>
                                    )}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="container">
                        Copyright ©2016 All Rights Reserved
              </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const {customer, pageSeo} = state
    return { customer, pageSeo }
}

export default connect(mapStateToProps)(withRouter(Footer))